"use strict";

exports.__esModule = true;
exports.loadScripts = void 0;
const mountSrc = src => {
  const node = document.createElement("script");
  /* eslint-disable fp/no-mutation */
  node.type = "text/javascript";
  node.async = true;
  node.src = src;
  /* eslint-enable fp/no-mutation */
  document.head.appendChild(node);
};
const mountInline = innerHTML => {
  const node = document.createElement("script");
  /* eslint-disable fp/no-mutation */
  node.type = "text/javascript";
  node.async = true;
  node.innerHTML = innerHTML;
  /* eslint-enable fp/no-mutation */
  document.head.appendChild(node);
};
const loadScripts = settings => {
  // those Array.from are to avoid non-existing .forEach on NodeArray in IE11

  Array.from(document.querySelectorAll("script[data-cookiescript='necessary']")).forEach(node => {
    if (node.src.length > 0) {
      mountSrc(node.src);
    } else {
      mountInline(node.innerHTML);
    }
  });
  if (settings.analytics) {
    Array.from(document.querySelectorAll("script[data-cookiescript='analytics']")).forEach(node => {
      if (node.src.length > 0) {
        mountSrc(node.src);
      } else {
        mountInline(node.innerHTML);
      }
    });
  }
  if (settings.marketing) {
    Array.from(document.querySelectorAll("script[data-cookiescript='marketing']")).forEach(node => {
      if (node.src.length > 0) {
        mountSrc(node.src);
      } else {
        mountInline(node.innerHTML);
      }
    });
  }
};
exports.loadScripts = loadScripts;